import React from "react";

const TotalCreativesSVG = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33301 11.8333L8.66634 13.1666C8.79766 13.2979 8.95356 13.4021 9.12515 13.4732C9.29673 13.5443 9.48062 13.5808 9.66634 13.5808C9.85206 13.5808 10.036 13.5443 10.2075 13.4732C10.3791 13.4021 10.535 13.2979 10.6663 13.1666C10.7977 13.0353 10.9018 12.8794 10.9729 12.7078C11.044 12.5362 11.0806 12.3523 11.0806 12.1666C11.0806 11.9809 11.044 11.797 10.9729 11.6254C10.9018 11.4538 10.7977 11.2979 10.6663 11.1666"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33348 9.8333L11.0002 11.5C11.2654 11.7652 11.6251 11.9142 12.0002 11.9142C12.3752 11.9142 12.7349 11.7652 13.0002 11.5C13.2654 11.2348 13.4144 10.875 13.4144 10.5C13.4144 10.1249 13.2654 9.76519 13.0002 9.49997L10.4135 6.9133C10.0385 6.53877 9.53015 6.3284 9.00015 6.3284C8.47015 6.3284 7.96182 6.53877 7.58682 6.9133L7.00015 7.49997C6.73493 7.76519 6.37522 7.91418 6.00015 7.91418C5.62508 7.91418 5.26537 7.76519 5.00015 7.49997C4.73493 7.23475 4.58594 6.87504 4.58594 6.49997C4.58594 6.1249 4.73493 5.76519 5.00015 5.49997L6.87348 3.62664C7.48165 3.02007 8.27475 2.63367 9.12725 2.52862C9.97974 2.42357 10.8429 2.60586 11.5802 3.04664L11.8935 3.2333C12.1773 3.40463 12.5148 3.46405 12.8402 3.39997L14.0002 3.16664"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.9997 2.5L14.6663 9.83333H13.333"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.99967 2.5L1.33301 9.83333L5.66634 14.1667C5.93156 14.4319 6.29127 14.5809 6.66634 14.5809C7.04141 14.5809 7.40112 14.4319 7.66634 14.1667C7.93156 13.9014 8.08056 13.5417 8.08056 13.1667C8.08056 12.7916 7.93156 12.4319 7.66634 12.1667"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 3.16663H7.33333"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TotalCreativesSVG;
